import store from '@/store'

// This module expects to receive a jsconn object
// it checks to see if the account has an issue
// as of 2018-08-02, the main issue is going to be with email
const checkAccount = (jsConn) => {
  // is the jsconn already halted?
  if (jsConn.halted) {
    return Promise.reject(jsConn)
  }

  // is the response in the response or error property
  if (jsConn.apiCallStatus === 'success') {
    // the api call was a success
    if (jsConn.response['data']['status'] === 'account issue') {
      // load the email in the store
      // this may get overwritten later, but we know enough to do it now
      store.dispatch('loadEmailAddress', jsConn.response['data']['payload']['user_account']['email'])

      jsConn.toRoutePath = '/check-email'
      jsConn.halted = true

      return Promise.reject(jsConn)
    } else {
      return Promise.resolve(jsConn)
    }
  } else {
    return Promise.resolve(jsConn)
  }
}

export { checkAccount }
